import { render, staticRenderFns } from "./CodeBasedIntranetAccess.vue?vue&type=template&id=fa8f8a1e&scoped=true&"
import script from "./CodeBasedIntranetAccess.vue?vue&type=script&lang=js&"
export * from "./CodeBasedIntranetAccess.vue?vue&type=script&lang=js&"
import style0 from "./CodeBasedIntranetAccess.vue?vue&type=style&index=0&id=fa8f8a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8f8a1e",
  null
  
)

export default component.exports